import type { AB_TESTS } from '../constants';
import { AB_TESTS_START_DATE } from '../constants';

export const isUserAppropriateForTest = (
  name: string,
  createdAt?: string | null
): boolean => {
  const matchingTest = (Object.keys(AB_TESTS_START_DATE) as AB_TESTS[]).find(
    (test) => name.startsWith(test)
  );
  const startDate = matchingTest
    ? AB_TESTS_START_DATE[matchingTest]
    : undefined;
  if (!startDate) return true;
  return !!createdAt && new Date(createdAt) > startDate;
};
